import { render, staticRenderFns } from "./OrderfulfillmentSettingCustomNew.vue?vue&type=template&id=99be3714&scoped=true"
import script from "./OrderfulfillmentSettingCustomNew.vue?vue&type=script&lang=js"
export * from "./OrderfulfillmentSettingCustomNew.vue?vue&type=script&lang=js"
import style0 from "./OrderfulfillmentSettingCustomNew.vue?vue&type=style&index=0&id=99be3714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99be3714",
  null
  
)

export default component.exports